import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';

import { LoaderComponent } from './loader/loader.component';
import { PlateCropPreviewComponent } from './plate-crop-preview/plate-crop-preview.component';
import { EmptyStateComponent } from './empty-state/empty-state.component';

import { TagPipe } from './pipe/pipe-tag';
import { TimePipe } from './pipe/pipe-time';
import { SortPipe } from './pipe/sort.pipe';
import { TranslateColorPipe } from './pipe/translate-color.pipe';
import { TranslateLandPipe } from './pipe/translate-land.pipe';
import { TranslateHerstellerPipe } from './pipe/translate-hersteller.pipe';
import { PadStringPipe } from './pipe/pad-string.pipe';

@NgModule({
  imports: [MatProgressSpinnerModule, MatIconModule, CommonModule],
  declarations: [
    LoaderComponent,
    PlateCropPreviewComponent,
    EmptyStateComponent,
    TagPipe,
    TimePipe,
    SortPipe,
    TranslateColorPipe,
    TranslateLandPipe,
    TranslateHerstellerPipe,
    PadStringPipe,
  ],
  exports: [
    LoaderComponent,
    PlateCropPreviewComponent,
    EmptyStateComponent,
    TagPipe,
    TimePipe,
    SortPipe,
    TranslateColorPipe,
    TranslateLandPipe,
    TranslateHerstellerPipe,
    PadStringPipe,
  ],
})
export class SharedModule {}
